import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { type DataBindingSourceInfo } from '@blaze-shared/elements-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const collapsibleContainerV2Migration: PropsMigration = {
  mode: 'props',
  description:
    'Migrate collapsible container to add opened data binding based on behavior expression',
  run: (props: PartialPropsOf<'collapsibleContainer'>): void => {
    const expression = (props.content as any)?.behaviorExpression;
    if (expression) {
      props.data ??= [];
      props.data.push({
        key: 'opened',
        enabled: true,
        dataSource: (<Partial<DataBindingSourceInfo>>{
          sourceType: 'expression',
          expression,
        }) as DataBindingSourceInfo,
      });
      delete (props.content as any).behaviorExpression;
    }
  },
};
